import { UIHeading5 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import styles from './Card.css';
import { IHeaderCard } from '../../../../../types/chatHeader';
import { CardImage } from '../CardImage';
import { CardSubtitle } from '../CardSubtitle';

type TCard = Omit<IHeaderCard, 'action'>;

export const Card: React.FC<TCard> = ({ image, title, subtitle }) => {
  return (
    <div className={styles['card']}>
      <div className={styles['image-container']}>
        <CardImage {...image} />
      </div>

      <div className={styles['info']}>
        <div className={clsx(styles['title'], { [styles['title_clamped']]: !subtitle })}>
          <UIHeading5>{title}</UIHeading5>
        </div>

        {subtitle && <CardSubtitle {...subtitle} />}
      </div>
    </div>
  );
};
